export default __webpack_public_path__ + "static/media/illustration-recruit-5-m@2x.895a0a72.webp";